<template>
  <div class="box_glow">
    <div class="box_glow_inner">
      <slot>
        <i
          class="mdi"
          style="font-size: clamp(1px, 4em, 6vw); line-height: 1"
          :class="box.icon"
          :style="`color:${box.iconColor}`"
        ></i>
        <h4
          style="margin: 0.875em 0 0 0"
          class="truncate"
        >
          {{ box.subtitle }}
        </h4>
        <h2
          style="margin: 0.5em 0 0 0; max-width: 100%"
          class="truncate"
        >
          {{ box.text }}
        </h2>
      </slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WrapupBox',
  props: {
    box: {
      type: Object,
      default: () => ({}),
    },
  },
}
</script>
<style lang="scss" scoped>
h1 {
  font-size: clamp(1px, 4.5em, 8vw);
  font-weight: 700;
  line-height: 1.2;
}
.section-title {
  font-size: clamp(1px, 3.5em, 7vw);
  font-weight: 700;
  line-height: 1.2;
}
h2 {
  font-size: clamp(1px, 2.5em, 6vw);
  // font-size: 3.5em;
  font-weight: 700;
  line-height: 1.2;
}
h3 {
  font-size: 2em;
  font-weight: 700;
  line-height: 1.2;
}
h4 {
  font-size: 1.5em;
  // font-weight: 500;
  font-weight: 700;
  line-height: 1.2;
}

.box_glow {
  position: relative;
  --border-width: 2px;
  --clr-1: var(--clr-primary);
  --clr-2: var(--clr-mtt);
  border-radius: 6px;
  --padding: 2em 2.5em;
  &_inner {
    border-radius: 6px;
    background: var(--clr-balck-0-3);
    background: linear-gradient(55deg, var(--clr-black-0-1), var(--clr-black-1));
    padding: var(--padding);
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 100%;
    overflow: hidden;
    // align-items: center;
    // justify-content: center;
  }
  &::before,
  &::after {
    content: '';
    z-index: -1;
    position: absolute;
    --size: calc(100% + (2 * var(--border-width)));
    --inset: calc(-1 * var(--border-width));
    width: var(--size);
    height: var(--size);
    top: var(--inset);
    left: var(--inset);
    border-radius: 8px;
    background: linear-gradient(45deg, var(--clr-1), var(--clr-2) 44%);
    background-size: 150%;
    animation: animBorder 8s infinite;
  }
  &::after {
    filter: blur(50px);
    transform: translate3d(0, 0, 0) !important; // Safari fix
  }
}

@keyframes animBorder {
  0% {
    background-position: 0 0;
  }
  50% {
    background-position: 100% 0;
  }
  100% {
    background-position: 0 0;
  }
}

@supports (-webkit-touch-callout: none) {
  .box_glow {
    &::after {
      filter: none !important;
    }
  }
}
</style>
